import languageStorage     from "@/assets/localization"
import { ErrorLogService, ObjectUtil, CacheService } from "@/services"

const defaultLanguageCode = "EN"

const state = {
  localizedContent: {},
  defaultContent: {}
}

const mutations = {
  SET_DEFAULT_CONTENT: function (state, defaultContent) {
    state.defaultContent = defaultContent
  },
  SET_LOCALIZED_CONTENT: function (state, localizedContent) {
    state.localizedContent = localizedContent
  }
}

const LANG_SETTINGS_CACHE_KEY = 'langSettings';
const LANG_SETTINGS_CACHE_MINUTES = 60; // 1 hour

const actions = {
  LOAD_LANGUAGES: ({ commit, dispatch }, languageCode) => {
    languageCode = languageCode.toString().toUpperCase();
    const cacheKey = `localizedContent_${languageCode}`;
    const cached = CacheService.get(LANG_SETTINGS_CACHE_KEY);

    var defaultLanguage = languageStorage.translations.find(translation => translation.language === defaultLanguageCode);
    commit("SET_DEFAULT_CONTENT", defaultLanguage);

    if (cached) {
      commit("SET_LOCALIZED_CONTENT", cached);
      return Promise.resolve(true);
    }

    var localLanguage = languageStorage.translations.find(translation => translation.language === languageCode);
    if (typeof localLanguage != "undefined") {
      commit("SET_LOCALIZED_CONTENT", localLanguage);
      CacheService.set(LANG_SETTINGS_CACHE_KEY, localLanguage, LANG_SETTINGS_CACHE_MINUTES);
    } else {
      commit("SET_LOCALIZED_CONTENT", defaultLanguage);
      CacheService.set(LANG_SETTINGS_CACHE_KEY, defaultLanguage, LANG_SETTINGS_CACHE_MINUTES);
    }
    return Promise.resolve(true);
  }
}

const getters = {
  getContentItem: (state) => (itemName) => {
    // default to English if the localized property doesn't exist
    const value = ObjectUtil.findValueByKey(state.localizedContent, itemName) || ObjectUtil.findValueByKey(state.defaultContent, itemName);

    if (typeof value != "undefined") {
      return value;
    }

    if (process.env !== "production") {
      console.warn(`Localization not found for dictionary item: ${itemName}`)
    }
    return `_${itemName}_`;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
